export function extractDeepLinkCode(link: string): string | undefined {
  if (!link.includes('link.groupcal')) return undefined

  const lastPart = link.split('/').pop()
  if (!lastPart) return undefined

  const code = lastPart.split('?')[0]
  return code
}
